export const scaledRemCalc = (size: number) =>
  size === 0 ? 0 : `calc(var(--slideshow-size-scale, 1) * ${size / 16}rem)`;
